export const queryEvent = groq`*[_type == "genericEvent" && currentPathname == $currentPathname][0]{
    ...
}`;
